export const CLARITY_MAP: Record<string, string> = {
  "app.labportal.vet": "v8g9oqqj80",
  localhost: "v8gftt8tzj",
};
